import { postRequest } from 'config/Axios/baseConfig';
import {
  ScheduleAttainmentPayload,
  ScheduleAttainmentResponse,
  ScheduleOverridePayload,
  ScheduleOverrideResponseSchema
} from 'Interfaces/JobsInterface';

export const ScheduleAttainmentServices = {
  saveScheduleAttainment: (
    payload: ScheduleOverridePayload[]
  ): Promise<ScheduleOverrideResponseSchema> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<ScheduleOverrideResponseSchema>(
          'pps/schedule-attainment/update-or-create/',
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  fetchScheduleAttainment: (
    payload: ScheduleAttainmentPayload
  ): Promise<ScheduleAttainmentResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<ScheduleAttainmentResponse>(
          'pps/schedule-attainment/',
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
